import React from 'react';
import clsx from 'clsx';
import { Accordion, AccordionItem, Icon } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import HistoryCards from './HistoryCards';
import styles from './SplitRevisionHistory.css';

type Props = {
    ruleId: string;
    level: HistoryRulesParams['level'];
    deploymentVersion?: number;
    merchantId?: string;
    tenantGroupId?: number;
    listData?: ListManagementApiList[];
    isLandlordDeployment?: boolean;
};

function SplitRevisionHistory({
    ruleId,
    deploymentVersion,
    level,
    merchantId,
    tenantGroupId,
    listData,
    isLandlordDeployment
}: Props) {
    const { t } = useTranslation();
    if (isLandlordDeployment) {
        return <></>;
    }

    return (
        <Accordion className={styles.accordion} noAutoCollapse>
            <AccordionItem
                name='revision'
                header={({ handleOnClick, handleKeyDown, expanded }) => {
                    return (
                        <div
                            className={clsx(styles.headerContainer, expanded && styles.borderBottom)}
                            tabIndex={0}
                            onClick={handleOnClick}
                            onKeyDown={handleKeyDown}
                            role='button'
                        >
                            <Icon className={styles.icon} size='md' name={expanded ? 'arrow-up-1' : 'arrow-down-1'} />
                            <h4 className={styles.header}>{t('Revision History')}</h4>
                        </div>
                    );
                }}
            >
                <HistoryCards
                    subjectIdentifier={level === 'MERCHANT' ? merchantId : tenantGroupId}
                    level={level}
                    ruleId={ruleId}
                    deploymentVersion={deploymentVersion}
                    listData={listData}
                />
            </AccordionItem>
        </Accordion>
    );
}

export default React.memo(SplitRevisionHistory);
